import React from 'react';
import { FaBalanceScale, FaFlagUsa, FaModx } from "react-icons/fa";
import './Feature.css';
const Features = () => {
    return (
        <div className='bg-base-200 py-20   '>
            <div className='max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3  '>
            <div className="feature-box bg-white text-center p-8 rounded-lg ">
                <div className="feature-content text-center">
                    <div className='flex justify-center'>
                    <div className="image-icon">
                       <FaModx className='text-3xl text-black'/>
                    </div>
                    </div>

                    <h2 className='text-2xl text-black font-bold my-4'>Professional Court Service</h2>
                    <p>Competently leverage existing enterprise wide niches through stand alone services. Quickly productize technically.</p>
                </div>
            </div>
            <div className="feature-box-middle bg-orange text-center p-8 rounded-lg ">
                <div className="feature-content text-center">
                    <div className='flex justify-center'>
                    <div className="image-icon">
                       <FaBalanceScale className='text-3xl text-black'/>
                    </div>
                    </div>

                    <h2 className='text-2xl text-black font-bold my-4'>Top Expart Attorney</h2>
                    <p>Competently leverage existing enterprise wide niches through stand alone services. Quickly productize technically.</p>
                </div>
            </div>
            <div className="feature-box bg-white text-center p-8 rounded-lg ">
                <div className="feature-content text-center">
                    <div className='flex justify-center'>
                    <div className="image-icon">
                       <FaFlagUsa className='text-3xl text-black'/>
                    </div>
                    </div>

                    <h2 className='text-2xl text-black font-bold my-4'>Competitive Pricing</h2>
                    <p>Competently leverage existing enterprise wide niches through stand alone services. Quickly productize technically.</p>
                </div>
            </div>
        </div>
        </div>
    );
};

export default Features;